import type { PlayEngineVersion } from "./engineVersion";

export type ChallengeVariant = {
  id: string;
  label: string;
  modelId: string;
  elo: number;
};

export type ChallengeCard = {
  id: string;
  label: string;
  title: string;
  subtitle: string;
  accent: "ember" | "steel" | "acid" | "blood";
  kind: "solo" | "group";
  elo: number;
  modelId?: string;
  variants?: ChallengeVariant[];
};

export const CATIE_3_MODEL_ID = "catie3.ctm";
export const CATIE_3_ELO = 2600;

export const legacyChallengeCards: ChallengeCard[] = [
  {
    id: "carlsen",
    label: "Solo",
    title: "Carlsen",
    subtitle: "Cold-blooded pressure",
    accent: "ember",
    kind: "solo",
    elo: 2850,
    modelId: "carlsen.best",
  },
  {
    id: "danya",
    label: "Solo",
    title: "Danya",
    subtitle: "Speed and turbulence",
    accent: "steel",
    kind: "solo",
    elo: 2700,
    modelId: "danya.best",
  },
  {
    id: "hikaru",
    label: "Solo",
    title: "Hikaru",
    subtitle: "Instant counterplay",
    accent: "acid",
    kind: "solo",
    elo: 2800,
    modelId: "hikaru.final",
  },
  {
    id: "jeffery",
    label: "Solo",
    title: "Jeffery",
    subtitle: "Precise attacking nerve",
    accent: "blood",
    kind: "solo",
    elo: 2700,
    modelId: "jefferyxiong.best",
  },
  {
    id: "nihal",
    label: "Solo",
    title: "Nihal",
    subtitle: "Narrow tactical blades",
    accent: "steel",
    kind: "solo",
    elo: 2650,
    modelId: "nihailsarin.best",
  },
  {
    id: "twic2400",
    label: "Group",
    title: "2400-2900",
    subtitle: "Version cluster",
    accent: "ember",
    kind: "group",
    elo: 2400,
    variants: [
      {
        id: "twic2400-a",
        label: "24002900 (A)",
        modelId: "twic24002900.bucket_aggressive.best",
        elo: 2400,
      },
      {
        id: "twic2400-b",
        label: "24002900 (B)",
        modelId: "twic24002900.bucket_balanced.best",
        elo: 2400,
      },
      {
        id: "twic2400-c",
        label: "24002900 (C)",
        modelId: "twic24002900.linear_max_2p0.best",
        elo: 2400,
      },
      {
        id: "twic2400-d",
        label: "24002900 (D)",
        modelId: "twic24002900.linear_max_3p0.best",
        elo: 2400,
      },
      {
        id: "twic2400-e",
        label: "24002900 (E)",
        modelId: "twic24002900.power_max_3p0_gamma_2.best",
        elo: 2400,
      },
      {
        id: "twic2400-f",
        label: "24002900 (F)",
        modelId: "twic24002900.unweighted.best",
        elo: 2400,
      },
    ],
  },
  {
    id: "twic2500",
    label: "Group",
    title: "2500-2900",
    subtitle: "Tournament crowd",
    accent: "acid",
    kind: "group",
    elo: 2500,
    modelId: "twic25002900.best",
  },
  {
    id: "twic2600",
    label: "Group",
    title: "2600-2900",
    subtitle: "Elite field",
    accent: "blood",
    kind: "group",
    elo: 2600,
    modelId: "twic26002900.best",
  },
  {
    id: "twic2700",
    label: "Group",
    title: "2700-2900",
    subtitle: "Monsters only",
    accent: "steel",
    kind: "group",
    elo: 2700,
    modelId: "twic27002900.best",
  },
];

export const catie3ChallengeCards: ChallengeCard[] = [
  {
    id: "catie3-ctm",
    label: "CTM",
    title: "Catie3.0",
    subtitle: "Continuous thought model",
    accent: "acid",
    kind: "solo",
    elo: CATIE_3_ELO,
    modelId: CATIE_3_MODEL_ID,
  },
];

export const challengeCards: ChallengeCard[] = legacyChallengeCards;

export function challengeCardsForEngineVersion(
  engineVersion: PlayEngineVersion,
): ChallengeCard[] {
  if (engineVersion === "catie_3_0") {
    return catie3ChallengeCards;
  }
  return legacyChallengeCards;
}

export const playTimePresets = [
  { label: "1+0", minutes: 1, incrementSeconds: 0 },
  { label: "2+1", minutes: 2, incrementSeconds: 1 },
  { label: "3+2", minutes: 3, incrementSeconds: 2 },
  { label: "5+3", minutes: 5, incrementSeconds: 3 },
  { label: "15+10", minutes: 15, incrementSeconds: 10 },
] as const;
